import _ from 'lodash';
import { ifElse } from 'ramda';

export function validateMsisdn(val, countryCode) {
  const { length } = val;
  const regexp = '^[0-9\\s]*$';
  const regex = new RegExp(regexp);
  const countryCodeLength = countryCode.length;
  const valSubstr = val.substring(0, countryCodeLength);

  if (!_.isEmpty(val)) {
    if (
      val === '' ||
      !regex.test(val) ||
      val.charAt(0) === '0' ||
      valSubstr.includes(countryCode)
    ) {
      return true;
    }
  }
}

export function getLS(item) {
  if (typeof localStorage !== 'undefined' || localStorage !== null) {
    if (localStorage.getItem(item) !== null) {
      return localStorage.getItem(item);
    }
    return null;
  }
  if (sessionStorage.getItem(item)) {
    return sessionStorage.getItem(item);
  }
  return null;
}

export function checkLSBlocked() {
  try {
    localStorage.setItem('test', 'test');
    localStorage.removeItem('test');

    // localStorage is not blocked
    return true;
  } catch (e) {
    // localStorage is blocked
    return false;
  }
}

export function setLS(name, val) {
  if (checkLSBlocked) {
    localStorage.setItem(name, val);
  } else {
    sessionStorage.setItem(name, val);
  }
}

export function removeLS(val) {
  if (checkLSBlocked) {
    localStorage.removeItem(val);
  } else {
    sessionStorage.removeItem(val);
  }
}

export function clearLS() {
  if (checkLSBlocked) {
    localStorage.clear();
  } else {
    sessionStorage.clear();
  }
}
